import styled from 'styled-components';

import Flex from '@components/layout/flex';

export const Wrapper = styled(Flex)`
  & > * {
    flex-grow: 1;
    width: 100%;
  }
`;

export const IconWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.iconBackground};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 10px;
    height: auto;
  }

  &.has-changes {
    background-color: ${({ theme }) => theme.colors.blackActive};
  }
`;
